// extracted by mini-css-extract-plugin
export var navigationItem = "NavItem-module--navigationItem--gaSRw";